export default class AtividadeTag {

  constructor(
    IdEmpresa = 1,
    IdAtividade = null,
    IdTag = null,
    Descricao = ''
  ) {

    this.IdEmpresa = IdEmpresa;
    this.IdAtividade = IdAtividade;
    this.IdTag = IdTag;
    this.Descricao = Descricao;
  }
  
}